import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import styled from '@emotion/styled';
import { ClassNames } from '@emotion/react';
import { TextButton } from '../../Button/index.js';
import { MainBodyText } from '../../Typography/index.js';
import { CSSTransition, FlexContainer } from '../../CSS/index.js';
import { IconStatus, IconUIElement, IconContainer } from '../../Icon/index.js';
import { snackbarPosition } from './position.js';
import { useKeyboardNavigation } from '../../../hooks/index.js';
const STATIC_SNACKBAR_BG = Object.freeze({
    info: 'linear-gradient(251deg, #49ace9, #4980e9)',
    error: 'none',
    success: 'none',
    warning: 'none'
});
const SnackbarContentContainer = styled.div(({ withActions }) => ({
    padding: '25px 15px',
    display: 'grid',
    alignItems: 'baseline',
    gridTemplateColumns: withActions
        ? '14px 1fr max-content 14px'
        : '14px 1fr 14px',
    gap: 10
}));
const SnackbarContainer = styled.div(({ isStatic, theme, index = 0, snackbarRole = 'info', position = 'top-center' }) => {
    if (isStatic) {
        return {
            zIndex: 999,
            maxWidth: 520,
            width: '100%',
            position: 'static',
            backgroundImage: STATIC_SNACKBAR_BG[snackbarRole],
            backgroundColor: theme.primaryBackgroundColor,
            borderRadius: 15,
            boxShadow: '0 4px 13px 0 rgba(12, 21, 27, 0.15)',
            transform: 'translate(0)',
            [`& ${SnackbarContentContainer}`]: {
                padding: '20px 15px'
            }
        };
    }
    return {
        zIndex: 99999,
        maxWidth: 520,
        width: '100%',
        position: 'fixed',
        background: theme.primaryBackgroundColor,
        borderRadius: 15,
        boxShadow: '0 4px 13px 0 rgba(12, 21, 27, 0.15)',
        ...snackbarPosition(index)[position]
    };
});
const TYPE_TO_ICON = Object.freeze({
    dynamic: {
        info: IconStatus.InfoFilled,
        error: IconStatus.ErrorFilled,
        success: IconStatus.SuccessFilled
    },
    static: {
        info: IconStatus.UnknownOutline,
        error: IconStatus.ErrorFilled,
        success: IconStatus.SuccessFilled
    }
});
const Snackbar = props => {
    const { id, role = 'info', content, onClose, isStatic, actions, withCloseButton = true } = props;
    const snackbarRef = useRef(null);
    useKeyboardNavigation(snackbarRef, content, id !== undefined && onClose ? () => onClose(id) : undefined);
    const RoleIcon = isStatic
        ? TYPE_TO_ICON.static[role]
        : TYPE_TO_ICON.dynamic[role];
    return (_jsx(ClassNames, { children: ({ css }) => (_jsx(CSSTransition, { timeout: 300, classNames: {
                exit: css({ opacity: 1 }),
                enter: css({ opacity: 0 }),
                enterActive: css({
                    opacity: 1,
                    transition: 'opacity 300ms ease-in'
                }),
                exitActive: css({ opacity: 0, transition: 'opacity 300ms ease-in' })
            }, children: _jsx(SnackbarContainer, { ...props, content: props.content, role: "dialog", ref: snackbarRef, "data-cy": "snackbar", snackbarRole: props.role, "aria-labelledby": "snackbarText", children: _jsxs(SnackbarContentContainer, { withActions: !!actions, children: [_jsx(IconContainer, { style: { width: 14, height: 14, top: 2 }, children: _jsx(RoleIcon, {}) }), _jsx(MainBodyText, { element: "p", id: "snackbarText", children: content }), actions && (_jsx(FlexContainer, { children: actions.map(({ text, onClick }) => (_jsx(TextButton, { onClick: onClick, children: text }, text))) })), withCloseButton && (_jsx(IconContainer, { type: "button", ariaLabel: "close notification", onClick: id !== undefined && onClose ? () => onClose(id) : undefined, style: { width: 10, height: 10, alignSelf: 'start' }, children: _jsx(IconUIElement.Close, {}) }))] }) }) }, id)) }));
};
export default Snackbar;
//# sourceMappingURL=index.js.map